function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.de0{fill:url(#SVGID_1_);}\n\t.de1{fill:url(#SVGID_2_);}\n\t.de2{fill:#ECF4F8;}\n\t.de3{font-family=\"Gotham-Bold, Gotham\";}\n\t.de4{font-size:30px;}\n\t.de5{font-size:42px;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "de0",
  d: "M574.6,753.6c26.8,0.6,53.7-0.5,80.4-3.4c18.5-2,36.8-5.4,54.7-10.3c13.3-3.6,26.2-8.6,38.6-14.8 c0.5-0.2,0.9-0.4,1.4-0.5c0.6-0.2,0.9-0.3,1.3-0.5l0.4-0.2l8.1-4.7l0.3-0.3c0.4-0.3,0.7-0.5,1.3-1c0.4-0.4,0.6-0.5,0.9-0.7 c0.7-0.6,1.3-1,1.8-1.3c7.3-4.9,14-10.5,20-16.8c15.4-16.2,24.7-35.7,27.9-58.5c2.1-14.5,1.8-29.4-0.7-45.7 c-2.5-16.1-6.6-31.9-12-47.2c-5.6-16-12.2-31.7-19.7-46.9c-5.7-11.8-12.1-23.9-19.5-36.9c-0.1-0.1-0.2-0.3-0.4-0.9 c-0.2-0.5-0.3-0.7-0.4-1l-0.2-0.4l-0.5-0.8l-2.5-4.3l-0.2-0.3c-0.2-0.2-0.3-0.4-0.5-0.7c-0.2-0.2-0.2-0.3-0.2-0.3 c-1.4-2.3-2.6-4.2-5.1-8.4c-5.9-9.7-8.6-14-12-19.3c-5.6-8.8-11.9-17.8-19.1-27.3c-8.3-11.2-17.3-21.9-26.8-32.1 c-12.8-13.5-25.5-24.5-39.1-33.5c-12.9-8.4-25.8-14.5-39.3-18c-19.5-5.2-40.1-4.5-59.2,1.9c-6.6,2.1-13,4.8-19,8.2 c-0.2,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.5,0.2c-0.4,0.2-0.6,0.2-0.9,0.3l-0.4,0.2l-7.4,4.3l0,0l-0.4,0.2l-0.3,0.3 c-0.2,0.2-0.4,0.3-0.7,0.6c-0.3,0.3-0.4,0.4-0.4,0.4c-11.6,7-22.4,15.8-34.5,27.7c-15.3,15-29.4,32.2-43.1,52.1 c-24.6,35.6-45,71.9-61.1,109.5c-7.3,16.8-13.2,34.2-17.6,52c-4.4,18-6.4,34.6-5.9,50.8c0.3,13.6,2.9,27,7.8,39.7 c0.7,1.8,1.3,3.1,2.7,6.2l0.1,0.1c0.6,1.4,1,2.1,1.3,2.9c0,0.1,0.1,0.1,0.1,0.2l0.1,0.2c0.1,0.3,0.2,0.5,0.2,0.7l0.2,0.5l3.8,6.5 l0.2,0.3c0.2,0.3,0.4,0.6,0.9,1.2l0.8,1.1c0.6,0.9,1.1,1.5,1.6,2.2c7.1,9.8,15.7,18.5,25.5,25.5c11.8,8.5,24.7,15.3,38.3,20.3 c15.7,6,32.5,10.4,51.5,13.7C520.9,751,546.2,753.1,574.6,753.6z M414.1,703.2c-8.8-6.3-16.5-14-22.8-22.8 c-0.5-0.7-1.1-1.5-1.8-2.4l-0.9-1.2L388,676l-2.8-4.9l-0.1-0.2c-0.2-0.5-0.4-1-0.6-1.5c-0.3-0.7-0.6-1.4-1.3-2.9l-0.1-0.1 c-1.3-2.8-1.8-4-2.4-5.5c-4.4-11.4-6.7-23.5-7-35.7c-0.5-15,1.4-30.6,5.5-47.6c4.2-17.1,9.9-33.9,16.9-50 c15.8-36.8,35.7-72.4,59.9-107.4c13.3-19.3,26.9-35.9,41.7-50.3c11.4-11.2,21.6-19.5,32.3-26c0.7-0.4,1.3-0.9,1.9-1.4 c0,0,0.1-0.1,0.1-0.1l6.2-3.6c0.1,0,0.2-0.1,0.3-0.1c0.3-0.1,0.4-0.2,0.6-0.2c0.7-0.3,1.4-0.6,2-1c5.3-3,10.9-5.4,16.8-7.2 c16.9-5.7,35.2-6.3,52.4-1.7c12.2,3.2,24,8.7,35.8,16.5c12.7,8.4,24.7,18.8,37,31.7c9.2,9.8,17.9,20.2,25.9,31 c7,9.3,13.1,18,18.5,26.6c3.4,5.3,6,9.5,11.9,19.1c2.6,4.2,3.7,6.1,5.2,8.4c0.3,0.5,0.7,1,1,1.4c0,0,0.1,0.1,0.1,0.1l2.5,4.2 c0.1,0.1,0.1,0.3,0.2,0.5c0.4,0.8,0.6,1.2,0.9,1.8c7.3,12.9,13.5,24.8,19.2,36.3c7.3,14.8,13.6,30.1,19.1,45.6 c5.2,14.6,9,29.7,11.5,45c2.3,15.2,2.6,29,0.7,42.2c-2.9,20.3-11.1,37.6-24.8,51.9c-5.5,5.7-11.5,10.8-18.1,15.1 c-0.8,0.5-1.6,1.1-2.5,1.8c-0.3,0.2-0.5,0.4-0.9,0.7c-0.4,0.3-0.6,0.5-0.8,0.7c-3.2,1.8-3.4,2-6.5,3.8c-0.1,0-0.3,0.1-0.5,0.2 c-1,0.3-2,0.7-2.9,1.2c-11.6,5.8-23.8,10.5-36.4,13.9c-17.3,4.7-35,8.1-52.8,10c-26.2,2.8-52.5,3.9-78.8,3.3 c-27.9-0.5-52.5-2.6-75.9-6.6c-18.3-3.2-34.4-7.4-49.3-13.1C437,717.4,425.1,711,414.1,703.2z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "de1",
  d: "M828.8,653.4c10.8-19.8,14.4-41,11.8-63.3c-1.9-15.5-6.5-30.3-12.7-44.5c-6.8-15.3-15-29.9-24.5-43.7 c-10-14.5-20.8-28.5-32.4-41.8c-9.5-11-19.4-21.6-29.6-32c-0.6-0.6-1.1-1.3-1.6-1.9l-4.1-4.1c-0.5-0.4-1-0.7-1.4-1.1 c-8.3-7.8-16.5-15.8-24.9-23.5c-8.5-7.8-17.4-15.2-26.5-22.3c-11.3-9-23.2-17.3-35.4-24.9c-15.1-9.2-30.7-17.2-47.6-22.8 c-13.9-4.6-28.2-7.4-42.9-7.3c-20,0-39.6,6-56.3,17c-5.8,3.7-11.2,7.9-16.1,12.7c-0.7,0.6-1.5,1.2-2.3,1.8l-6,6 c-0.4,0.6-0.9,1.2-1.4,1.8c-10.6,10.9-19,23.4-26.7,36.4c-11.9,20.2-21.3,41.6-29.2,63.7c-14.7,41.2-25.7,83.4-32,126.8 c-2.8,18.7-4,37.7-3.7,56.6c0.4,17.5,2.5,34.8,7.6,51.6c3.8,13,9.8,25.3,17.8,36.3c2,2.8,4.3,5.3,6.5,8c0.4,0.5,0.7,0.9,1,1.4l5,5 c1.6,1.2,3.1,2.5,4.7,3.7c9.4,7.6,19.9,13.7,31.2,18c13.8,5.2,28.2,8.5,42.9,9.8c18.3,1.9,36.7,1.5,55-0.1c27-2.5,53.6-7.6,80-14.1 c27.2-6.6,54-15,80.1-25.1c18-6.9,35.3-15.3,51.9-25c12.2-7.1,23.7-15.4,34.2-24.8c1-0.8,1.9-1.5,3-2.2l6.3-6.3 c1.1-1.5,2.2-3,3.4-4.4C819.5,668.2,824.6,661,828.8,653.4z"
});

var SvgDonationExchange = function SvgDonationExchange(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 479.6 464.6",
    style: {
      enableBackground: "new 0 0 479.6 464.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    transform: "translate(-361.75 -313.506)"
  }, React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.9099,
    y1: 739.7075,
    x2: 744.5443,
    y2: 419.2233
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD5E5E"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9A8B"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref3, React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 421.9013,
    y1: 746.0978,
    x2: 736.3773,
    y2: 422.6915
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FD5E5E"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9A8B"
    }
  }), React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _ref4));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDonationExchange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/donation-exchange.4e00c4c5.svg";
export { ForwardRef as ReactComponent };